<template>
  <div class="faq-question">
    <div class="title-and-toggle-container">
      <h3 class="slate-bold">{{ question.title }}</h3>
      <button class="btn" @click="toggle()">
        <img
          v-if="!isOpen"
          src="@/assets/icons/ui/add-circle-outline-dark.svg"
          alt="open icon"
        />
        <img
          v-if="isOpen"
          src="@/assets/icons/ui/remove-circle-outline-dark.svg"
          alt="open icon"
        />
      </button>
    </div>

    <div class="content" :class="{ open: isOpen }">
      <div
        class="div-content-item"
        v-for="(content, questionIndex) in question.content"
        :key="'q-' + questionIndex + '-s-' + sectionKey"
      >
        <!-- Paragraph -->
        <p v-if="content.type === 'p'">{{ content.text }}</p>

        <!-- List -->
        <ul v-if="content.type === 'list'">
          <li
            v-for="(item, i) in content.items"
            :key="sectionKey + '-' + questionIndex + '-' + i"
          >
            {{ item }}
          </li>
        </ul>

        <!-- Image -->
        <img v-if="content.type === 'img'" :src="content.src" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HowToItem",
  props: ["question", "sectionKey"],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.faq-question {
  border-bottom: 1px solid $borderColor;
  padding: 0.75rem 0;
  .title-and-toggle-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.75rem 0;

    h3 {
      font-size: 1.5rem;
    }
  }

  .content {
    max-height: 0;
    overflow: hidden;
    margin-bottom: 0.5rem;

    transform-origin: top;
    transition: max-height 0.2s ease-in-out;

    &.open {
      max-height: 30rem;
    }

    p,
    li {
      margin-bottom: 1rem;
      width: 75%;
      line-height: 1.75rem;
    }

    ul {
      margin-left: .5rem;
      list-style: none;
    }
  }
}
</style>